import { render, staticRenderFns } from "./TutorialMask.vue?vue&type=template&id=7172be12"
import script from "./TutorialMask.vue?vue&type=script&lang=js"
export * from "./TutorialMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports